// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
  },
	selector: {
		topSorting: '#sort-filter',
	}
};
var isFirstLoad = false;
(function() {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		firstVariant = {};

	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		itemHtml = itemHtml.replace(/{{label_color}}/g, boostPFSConfig.custom.label_color);
		itemHtml = itemHtml.replace(/{{label_shape}}/g, boostPFSConfig.custom.label_shape);
		itemHtml = itemHtml.replace(/{{text_alignment}}/g, boostPFSConfig.custom.text_alignment);

		// Add Label
		var itemLabelsHtml = '';
		itemLabelsHtml += '<div class="product--label-container" data-item="overline">';
		if (soldOut) {
			itemLabelsHtml += '<div class="product--label">' + boostPFSConfig.label.out_of_stock + '</div>';
		} else if (boostPFSConfig.custom.show_sale_label && onSale) {
			if(boostPFSConfig.custom.show_sale_label === 'show-percent') {
				var salePercent = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_max);
				itemLabelsHtml += '<div class="product--label">' + salePercent + '% ' + boostPFSConfig.label.off + '</div>';
			} else {
				itemLabelsHtml += '<div class="product--label">' + boostPFSConfig.label.sale + '</div>';
			}
		} else if (boostPFSConfig.custom.show_new_label) {
			var isNewProduct = false;
			var now_timestamp = new Date();
			now_timestamp = now_timestamp.getTime() / 1000;
			var new_label_period_in_seconds = boostPFSConfig.custom.new_label_period * 86400;
			var valid_date = now_timestamp - new_label_period_in_seconds;
			var publish_date = new Date(data.published_at);
			publish_date = publish_date.getTime() / 1000;
			if (valid_date < publish_date) isNewProduct = true;
			if (isNewProduct) {
				itemLabelsHtml += '<div class="product--label">' + boostPFSConfig.label.new + '</div>';
			}
		}

		if (boostPFSConfig.custom.featured_tags.length > 0) {
			var featured_tags = boostPFSConfig.custom.featured_tags.split(',');
			for (var i = 0; i < featured_tags.length; i++){
				var formatted_featured_tag = featured_tags[i].toLowerCase();
				for (var j = 0; j < data.tags.length; j++) {
					if (formatted_featured_tag == data.tags[j]) {
						itemLabelsHtml += '<div class="product--label">' + Utils.escape(formatted_featured_tag) + '</div>';
					}
					break;
				}
			}
		}
		itemLabelsHtml += '</div>';
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
		// Add Images
		var itemImagesHtml = '';
		var hoverImagesHtml = '';
		if (images.length == 0) {
			images[0] = {
				'src': boostPFSConfig.general.no_image_url,
				'width': 500,
				'height': 500
			}
		}
		if (images.length > 0) {
			itemImagesHtml += '<div class="image--root" style="width: 100%;">';
			var aspect_ratio = images[0].width / images[0].height;
			itemImagesHtml += '<div class="image--container" style="padding-top:' + 1 / aspect_ratio * 100 + '%;">';
			var image_url = Utils.optimizeImage(images[0].src, '{width}x');
			itemImagesHtml += '<img class="lazyload" data-src="' + image_url + '" data-sizes="auto" data-widths="[295,394,590,700,800,1000,1200,1500,1800,2000,2400]" alt="{{itemTitle}}">';
			itemImagesHtml += '</div>';
			itemImagesHtml += '<noscript><img src="' + Utils.optimizeImage(images[0].src, '1024x1024') + '" alt="{{itemTitle}}"></noscript>';
			itemImagesHtml += '</div>';
		}

		if (images.length > 1) {
			hoverImagesHtml += '<div class="product--hover-image" data-item="image">';
			hoverImagesHtml += '<div class="image--root" style="width: 100%;">';
			var aspect_ratio = images[1].width / images[1].height;
			hoverImagesHtml += '<div class="image--container" style="padding-top:' + 1 / aspect_ratio * 100 + '%;">';
			var image_url = Utils.optimizeImage(images[1].src, '{width}x');
			hoverImagesHtml += '<img class="lazyload" data-src="' + image_url + '" data-sizes="auto" data-widths="[295,394,590,700,800,1000,1200,1500,1800,2000,2400]" alt="{{itemTitle}}">';
			hoverImagesHtml += '</div>';
			hoverImagesHtml += '<noscript><img src="' + Utils.optimizeImage(images[0].src, '1024x1024') + '" alt="{{itemTitle}}"></noscript>';
			hoverImagesHtml += '</div></div>';
		}
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
		itemHtml = itemHtml.replace(/{{itemHoverImages}}/g, hoverImagesHtml);
		if (boostPFSConfig.custom.hover_image_enabled && hoverImagesHtml != '') {
			itemHtml = itemHtml.replace(/{{data-hover-image}}/g, 'data-hover-image="loaded"');
		} else {
			itemHtml = itemHtml.replace(/{{data-hover-image}}/g, '');
		}

		// Add quick view
		var itemQuickViewHtml = '';
		if (!soldOut && boostPFSConfig.custom.quick_add_enable) {
			itemQuickViewHtml += '<div class="product--quick-add" tabindex="0" data-product-id="{{itemId}}-" data-off-canvas--open="right-sidebar" style="display: none"';
			if (firstVariant.title == 'Default Title') {
				itemQuickViewHtml += 'data-off-canvas--view="cart" data-loading="false"';
			} else {
				itemQuickViewHtml += 'data-off-canvas--view="product-form"';
			}
			itemQuickViewHtml += ' aria-haspopup="menu">';
			if (firstVariant.title == 'Default Title') {
				itemQuickViewHtml += 	'<div class="product--plus"><svg class="icon--root icon--plus" width="10" height="10" viewBox="0 0 10 10"><path d="M10 5.714H5.714V10H4.286V5.714H0V4.286h4.286V0h1.428v4.286H10z" fill-rule="nonzero" /></svg></div>' +
										'<div class="product--spinner"><svg class="spinner--root" style="display: block; shape-rendering: auto;" width="45px" height="45px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" > <g transform="rotate(0 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.8391608391608392s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(27.692307692307693 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.7692307692307692s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(55.38461538461539 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.6993006993006993s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(83.07692307692308 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.6293706293706294s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(110.76923076923077 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.5594405594405594s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(138.46153846153845 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.4895104895104895s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(166.15384615384616 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.4195804195804196s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(193.84615384615384 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.34965034965034963s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(221.53846153846155 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.2797202797202797s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(249.23076923076923 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.2097902097902098s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(276.9230769230769 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.13986013986013984s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(304.61538461538464 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="-0.06993006993006992s" repeatCount="indefinite" ></animate> </rect> </g> <g transform="rotate(332.3076923076923 50 50)"> <rect x="48" y="24.5" rx="0" ry="0" width="4" height="13"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.9090909090909091s" begin="0s" repeatCount="indefinite" ></animate> </rect> </g> </svg></div>';
			} else {
				itemQuickViewHtml += '<div class="product--ellipses"><svg class="icon--root icon--ellipses" viewBox="0 0 17 5"> <g fill-rule="nonzero"> <path d="M2.516.622c-.962 0-1.75.788-1.75 1.75 0 .963.788 1.75 1.75 1.75.963 0 1.75-.787 1.75-1.75 0-.962-.787-1.75-1.75-1.75zM14.516.622c-.962 0-1.75.788-1.75 1.75 0 .963.788 1.75 1.75 1.75.963 0 1.75-.787 1.75-1.75 0-.962-.787-1.75-1.75-1.75zM8.516.622c-.962 0-1.75.788-1.75 1.75 0 .963.788 1.75 1.75 1.75.963 0 1.75-.787 1.75-1.75 0-.962-.787-1.75-1.75-1.75z" /> </g> </svg></div>';
			}
			itemQuickViewHtml += '</div>';
		}
		itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

		// Add vendor
		var itemVendorHtml = ''
		if (boostPFSConfig.custom.show_vendor) {
			itemVendorHtml += '<div class="product--vendor" data-item="light-accent-text">{{itemVendorLabel}}</div>';
		}
		itemHtml = itemHtml.replace(/{{displayVendor}}/g, itemVendorHtml);

		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviewHtml = '';
			var rating_count = Utils.getProductMetafield(data, 'reviews', 'rating_count') || '';
			var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
			if (boostPFSThemeConfig.custom.hasOwnProperty('rating_enabled') &&
				boostPFSThemeConfig.custom.rating_enabled &&
				ratingObj && rating_count) {
				var rating_integer = Math.floor(ratingObj.value.rating);
				var rating_decimal = parseFloat(ratingObj.value.rating).toFixed(2);
				var product_rating = boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)
				itemReviewHtml = '<div class="product-rating--root" role="img" aria-label="'
				itemReviewHtml += product_rating;
				itemReviewHtml += '" style=--rating:';
				itemReviewHtml += rating_integer;
				itemReviewHtml += "; --rating-max:";
				itemReviewHtml += ratingObj.value.scale_max;
				itemReviewHtml += "; --rating-decimal:";
				itemReviewHtml += rating_decimal;
				itemReviewHtml += '">';
				itemReviewHtml += '<div class="product-rating--stars"></div>';
				itemReviewHtml += '<span class="product-rating--count" data-item="accent-text" aria-label="';
				itemReviewHtml += boostPFSConfig.label.total_reviews;
				itemReviewHtml += '">';
				itemReviewHtml += rating_count;
				itemReviewHtml += '</span></div>';
			}
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml);
		}

		//Add Swatch
		var itemSwatchesHtml = '';
		itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatchesHtml);

		//Add Swatch column
		var itemSwatchesColumnViewHtml = '';
		itemHtml = itemHtml.replace(/{{itemSwatchesColumnView}}/g, itemSwatchesColumnViewHtml);

		//Add form
		var itemFormHtml = '';
		itemHtml = itemHtml.replace(/{{itemForm}}/g, itemFormHtml);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
		return itemHtml;
	};
	// Build Product List Item
	ProductListItem.prototype.compileTemplate = function(data) {
		return ProductGridItem.compileTemplate(data);
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/

	function buildPrice(data) {
		var html = '';

		html = '<div class="product--price-container">';
		html += '<div class="product--price-wrapper">';
		if (onSale) {
			html += '<span class="product--compare-price money" data-item="light-accent-text">' + Utils.formatMoney(data.compare_at_price_min) + '</span>&nbsp;';
			html += '<span class="product--price money" data-item="accent-text">' + Utils.formatMoney(data.price_min) + '</span> ';
		} else {
			if (priceVaries) {
				html += '<span class="product--from" data-item="accent-text">' + (boostPFSThemeConfig.label.from) + ' ' + '</span>';
			}
			html += '<span class="product--price money" data-item="accent-text">' + Utils.formatMoney(data.price_min) + '</span>';
		}
		html += '</div>';
		html += '<div class="product--unit-price-container" data-item="small-text"></div>';
		html += '</div>';
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 2 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 3 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 3 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 2 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 2 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 2 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		paginationHtml = paginationHtml.replace(/{{previous}}/g, boostPFSConfig.label.previous);
		paginationHtml = paginationHtml.replace(/{{next}}/g, boostPFSConfig.label.next);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var active = false;
					if (paramSort == k) {
						active = true;
					}
					sortingItemsHtml += '<li class="filter--link">'
					sortingItemsHtml += '<input id="filter--sort--' + k + '" class="filter--input" type="radio" name="sort_by" value="' + k + '" data-label="' + sortingArr[k] + '" tabindex="-1"'
					sortingItemsHtml += active ? 'checked>' : '>'
					sortingItemsHtml += '<label class="filter--label" data-item="nav-text--sub" tabindex="0">'
					sortingItemsHtml += sortingArr[k]
					sortingItemsHtml += active ? '<svg class="icon--root icon--cross" viewBox="0 0 20 20"><path d="M10 8.727L17.944.783l1.273 1.273L11.273 10l7.944 7.944-1.273 1.273L10 11.273l-7.944 7.944-1.273-1.273L8.727 10 .783 2.056 2.056.783 10 8.727z" fill-rule="nonzero" /></svg>' : ''
					sortingItemsHtml += '</label></li>'
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
			return html;
		}
	};

	ProductSorting.prototype.bindEvents = function() {
		jQ(Selector.topSorting + ' .filter--label').off('click');
		jQ(Selector.topSorting + ' .filter--label').click(function(event) {
			// Append "sort" param to url
			// Used to Scroll to the previous position after returning from Product page
			if(!jQ(this).prev('input')) return;
			if(jQ(this).prev('input').is(':checked')) {
				FilterApi.setParam('sort', 'title-ascending');
			} else {
				FilterApi.setParam('sort', jQ(this).prev('input').attr('value'));
			}
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		})
	}

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		//Trigger click to the match height image
		//jQ('.collection--navigation--layout > div[data-active="true"]').trigger('click');
		jQ(document).on('click', '.boost-pfs-search-result-panel-item', function() {
			jQ('.navigation--layout-button[data-active="true"]').trigger('click')
		});

		if (boostPFSConfig.custom.quick_add_enable) {
			this.buildExtrasProductListByAjax(data, 'boost-pfs-quickview', function(results) {
				results.forEach(function(result) {
					jQ('#' + result.id).find('a').after(result.quickview);
				});
				jQ('.product--quick-add').show();
				jQ('.product--quick-add').on('click', function() {
					// Fix cannot select option on quick view
					if (typeof theme.utils.loadJsClasses !== 'undefined') theme.utils.loadJsClasses();
				})
			});
			if (theme && theme.partials && theme.partials.OffCanvas && typeof theme.partials.OffCanvas.load !== 'undefined') theme.partials.OffCanvas.load();
      if (theme && theme.off_canvas && typeof theme.off_canvas.load !== 'undefined') theme.off_canvas.load();
		}

		//Trigger match height image event in search page
		if (Utils.isSearchPage()) {
			window.innerWidth--;
			window.dispatchEvent(new Event('resize'));
		}
	};

	var _isScrollToBottom = ProductPaginationInfinite.prototype._isScrollToBottom;
	ProductPaginationInfinite.prototype._isScrollToBottom = function() {
		// Don't load new page when off canvas is opening
		if(jQ('.off-canvas--right-sidebar') && jQ('.off-canvas--right-sidebar').css('display') === 'block') return false;
		return _isScrollToBottom.call(this);
	}

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		// Handle duplicate pfs and search origin theme, if turn on option instant search then hide search origin theme
		jQ(window).on('load', function() {
			if (jQ('body').find('.boost-pfs-search-suggestion-wrapper').length > 0) {
				jQ('body').addClass('boost-has-setting-instant-search');
			}
		})
    //Recall match height image - for version 8.4.0 & above
		reMatchImageHeight();
    jQ('.navigation--layout-button').on('click', reMatchImageHeight());
    jQ('.boost-pfs-filter-tree-desktop-button-wrapper').on('click', function() {
      setTimeout(() => {
        if (!Utils.isSearchPage() && theme && theme.utils && typeof theme.utils.matchImageHeights !== 'undefined') {
          // Avoid auto scroll with infinite pagination
          theme.utils.matchImageHeights(document.querySelector('.collection--body--grid'), document.querySelectorAll('.product--root'), '.product--image-wrapper');
        }
      }, 100)
    });
	};

  function reMatchImageHeight() {
    if (!Utils.isSearchPage() && theme && theme.utils && typeof theme.utils.matchImageHeights !== 'undefined') {
      // Avoid auto scroll with infinite pagination
      theme.utils.matchImageHeights(document.querySelector('.collection--body--grid'), document.querySelectorAll('.product--root'), '.product--image-wrapper');
    }
  }
})();